import React from 'react';
import { Button } from '@shadcn/components/ui/button';
import { Badge } from '@shadcn/components/ui/badge';

import { StatusBadge } from '../TicketSystem/StatusBadge';
import { META_STATUS, META_STATUS_LABELS } from '../../constants';


const QuickStatusFilters = ({ 
  statistics, 
  activeMetaStatus, 
  onStatusClick 
}) => {
  const ticketsByMetaStatus = statistics?.ticketsByMetaStatus || {};
  const totalTickets = statistics?.totalTickets || 0;


  const getStatusCount = (status) => {
    return ticketsByMetaStatus[status] || 0;
  };

  
  const calculatePercentage = (count) => {
    return totalTickets > 0 ? Math.round((count / totalTickets) * 100) : 0;
  };

  return (
    <div className="flex items-center gap-2 flex-wrap">
      <span className="text-sm font-medium text-gray-700">Quick filters:</span>
      
    
      <Button
        variant={!activeMetaStatus ? "default" : "outline"}
        size="sm"
        onClick={() => onStatusClick('')}
        className="flex items-center gap-2"
      >
        All Tickets
        <Badge variant="secondary" className="ml-1">
          {totalTickets}
        </Badge>
      </Button>

      {/* Status Filters */}
      {Object.values(META_STATUS).map(status => {
        const count = getStatusCount(status);
        const percentage = calculatePercentage(count);
        const isActive = activeMetaStatus === status;
        
        return (
          <Button
            key={status}
            variant={isActive ? "default" : "outline"}
            size="sm"
            onClick={() => onStatusClick(status)}
            className="flex items-center gap-2"
            disabled={count === 0}
          >
            <StatusBadge 
              metaStatus={status}
              showOriginal={false}
            />
            <Badge 
              variant={isActive ? "secondary" : "outline"} 
              className="ml-1"
            >
              {count}
            </Badge>
            {count > 0 && (
              <span className="text-xs text-muted-foreground ml-1">
                ({percentage}%)
              </span>
            )}
          </Button>
        );
      })}
    </div>
  );
};

export default QuickStatusFilters;
